import { BrmTitledPane } from "./TitledPane";

export default BrmTitledPane;
